import { connect } from 'react-redux';
import { CheckoutState } from '../../state';
import { ExpressCheckoutProps } from './ExpressCheckout';

const _mapStateToProps = (
    state: CheckoutState,
): Partial<ExpressCheckoutProps> => {
    const { applepay } = state;
    return {
        applePay: applepay,
    };
};

export type ConnectedProps = ReturnType<typeof _mapStateToProps>;

export const connectExpressCheckout = connect(_mapStateToProps);
